import aat from "@/data/aat";
import {
  normalizeFieldToArray,
  getClassifiedAs,
  getValueOrContent
} from "@thegetty/linkedart.js";
import { Renderer } from "marked";

const IDENTIFIED_BY = "identified_by";
/**
 * We extend the default marked renderer to allow us to strip certain tag(s) from the markdown but retain the text
 */

class LinkRenderer extends Renderer {
  /**
   * strips the bold/Strong tag from the Markdown
   *
   * @param {object} token
   * @returns  {string}
   */
  strong(token) {
    return token.text;
  }
  /**
   * renders the italics
   *
   * @param {object} token
   * @returns
   */
  em(token) {
    return `<em>${token.text}</em>`;
  }
  /**
   * maintains the incoming text
   *
   * @param {object} token
   * @returns {string}
   */
  text(token) {
    return token.text;
  }
}

export const linkRenderer = new LinkRenderer();
// create different renderer for a series in the ContainerList
export const seriesContainerListRenderer = new LinkRenderer();
// update how links are rendered for series within the ContainerList
// adds negative tabindex so they are not included in tabbing
const seriesContainerListRendererLink = seriesContainerListRenderer.link;
seriesContainerListRenderer.link = (href, title, text) => {
  const html = seriesContainerListRendererLink.call(
    seriesContainerListRenderer,
    href,
    title,
    text
  );
  return html.replace(/^<a /, `<a tabindex="-1" `);
};

/**
 * Returns the alternative (markdown) version of a name
 *
 * @param {object} object - the JSON-LD object
 *
 * @returns {string|undefined}
 */
export function getNameWithMarkdown(object) {
  let identified_by = normalizeFieldToArray(object, IDENTIFIED_BY);
  if (identified_by.length == 0) {
    return undefined;
  }

  let names = getClassifiedAs(identified_by, aat.PREFERRED_TERMS);
  let toReturn = [];
  names.forEach((name) => {
    if (Array.isArray(name["alternative"])) {
      name["alternative"].forEach((version) => {
        if (
          version.format == "text/markdown" ||
          version.contentType == "text/markdown"
        ) {
          toReturn.push(getValueOrContent(version));
        }
      });
    }
  });
  return toReturn[0];
}

/**
 * This escapes common markdown characters so they can be displayed in Markdown renderers without issue
 *
 * @param {string} value - the text to escape
 *
 * @returns {undefined|string}
 */
export function escapeMarkdownCharacters(value) {
  if (value == undefined) {
    return undefined;
  }
  // escape *
  let toReturn = value.trim().replaceAll(/\*/g, "\\*");
  // escape _ only at the beginning or end of a word
  toReturn = toReturn.replaceAll(/^_|_$/g, "\\_");
  toReturn = toReturn.replaceAll(/_\s/g, "\\_ ");
  toReturn = toReturn.replaceAll(/\s_/g, " \\_");

  // cleanup newlines (? is this needed)
  // value = value.replaceAll(/\n/g, "<br>");

  return toReturn;
}
